// Productoras que se muestran en el home como UNA sola entrada que lleva a su
// página (/productoras/<slug>), en lugar de una por evento: un slide en el
// banner y una card primera en la grilla y en "Esta semana".
// Sirve para festivales con varias noches cargadas como eventos separados.
//
// Es una lista fija a propósito: por ahora hay un solo caso. Si aparecen más,
// esto pasa a ser un switch de Root en la productora servido por la API.
//
// Fechas, orden y vencimiento salen de los eventos públicos de la productora:
// el rango de fechas se arma solo, el slide toma la prioridad más alta de sus
// eventos y desaparece cuando ya no le quedan eventos en el listado.
export interface FeaturedBusiness {
  businessId: string;
  slug: string;
  name: string;
  /** Sin valor → el banner del evento con más prioridad de la productora. */
  bannerImage?: string;
  /** Sin valor → el lugar de los eventos, si todos comparten el mismo. */
  place?: string;
  subtitle?: string;
  ctaLabel?: string;
}

export const FEATURED_BUSINESSES: FeaturedBusiness[] = [
  {
    businessId: '534cba9e-5745-4a9c-9308-b2f5777e8e1e',
    slug: 'fiesta-nacional-de-la-tradicion',
    name: 'Fiesta Nacional de la Tradición 2026',
    // Provisorio: es el banner de la noche del sábado 14 (dice esa fecha).
    // Reemplazar por una pieza de las dos noches cuando esté.
    bannerImage: 'https://cdn.avantti.io/banner-14-de-noviembrejpeg_0f9e90',
    place: 'Anfiteatro Buenaventura Luna, Jáchal',
    subtitle: 'Soledad · Christian Herrera · Canto 4 · Sergio Galleguillo y más',
    ctaLabel: 'Elegí tu noche',
  },
];
